import React, { useEffect, useState } from "react";
import { Box, Heading, useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { MaterialForm } from "./MaterialMaster";
import lookupsService from "../services/lookupsService";
import materialsService from "../services/materialsService";
import { useUser } from "../context/UserContext";

const MaterialCreate = () => {
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [uoms, setUoms] = useState([]);
  const [taxCategories, setTaxCategories] = useState([]);
  const navigate = useNavigate();
  const toast = useToast();
  const { tenant } = useUser();

  const loadLookups = async () => {
    try {
      const [cats, brs, u, taxes] = await Promise.all([
        lookupsService.getCategories(),
        lookupsService.getBrands(),
        lookupsService.getUOMs(),
        lookupsService.getTaxCategories(),
      ]);
      setCategories(cats);
      setBrands(brs);
      setUoms(u);
      setTaxCategories(taxes);
    } catch (e) {
      console.warn("Failed to load lookups", e);
    }
  };

  useEffect(() => {
    loadLookups();
  }, []);

  const handleSubmit = async (payload) => {
    try {
      const payloadToSend = { ...payload };
      ["_id", "__v", "createdBy", "updatedBy", "deletedAt", "createdAt", "updatedAt"].forEach((k) => delete payloadToSend[k]);
      if (tenant && (tenant._id || tenant.id)) payloadToSend.tenantId = tenant._id || tenant.id;
      await materialsService.createMaterial(payloadToSend);
      toast({ title: "Material created", status: "success", duration: 3000 });
      navigate("/materials");
    } catch (e) {
      console.error(e);
      toast({ title: "Failed to create material", status: "error", duration: 4000 });
    }
  };

  return (
    <Box p={6}>
      <Heading size="md" mb={4}>New Material</Heading>
      <MaterialForm
        initial={{}}
        onSubmit={handleSubmit}
        onCancel={() => navigate("/materials")}
        inline
        categories={categories}
        brands={brands}
        uoms={uoms}
        taxCategories={taxCategories}
        onRefreshLookups={loadLookups}
      />
    </Box>
  );
};

export default MaterialCreate;
